// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fad3f5bd","787":"a976a22c","829":"a8f0cd4d"}[chunkId] + ".chunk.js";
};